import { render, staticRenderFns } from "./ModalCadastroSeguradoras.vue?vue&type=template&id=1c889583"
import script from "./ModalCadastroSeguradoras.vue?vue&type=script&lang=js"
export * from "./ModalCadastroSeguradoras.vue?vue&type=script&lang=js"
import style0 from "./ModalCadastroSeguradoras.vue?vue&type=style&index=0&id=1c889583&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports